import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

import type { ShareChannel as PageShareChannel } from '#src/app/pages/psf/promoteOrShare/shared/types';
import type { ShareAction, ShareChannel } from '#src/app/shared/hooks/share';

const SHARE_BUTTON_CONFIG: Readonly<
	Record<PageShareChannel, { label: TranslationKey; successLabel?: TranslationKey; secondaryLabel?: TranslationKey }>
> = {
	facebook: { label: translationKey('fe.components.psf.share.buttons.short.facebook') },
	facebookMessenger: { label: translationKey('fe.components.psf.share.buttons.short.facebook_messenger') },
	twitter: { label: translationKey('fe.components.psf.share.buttons.short.twitter') },
	whatsapp: { label: translationKey('fe.components.psf.share.buttons.short.whatsapp') },
	instagram: { label: translationKey('fe.components.psf.share.buttons.short.instagram') },
	line: { label: translationKey('fe.components.psf.share.buttons.short.line') },
	email: { label: translationKey('fe.components.psf.share.buttons.short.email') },
	sms: { label: translationKey('fe.components.psf.share.buttons.short.sms') },
	copy: {
		label: translationKey('fe.components.psf.share.buttons.copy_link'),
		successLabel: translationKey('fe.components.share_buttons.copied'),
		secondaryLabel: translationKey('corgi.psf.share.buttons.share_link_label'),
	},
	vk: { label: translationKey('fe.components.psf.share.buttons.short.vk') },
	nextdoor: { label: translationKey('corgi.psf.share.buttons.short.nextdoor') },
	mobileNativeShare: { label: translationKey('corgi.psf.share.buttons.short.mobile_share') },
	reddit: { label: translationKey('corgi.psf.share.buttons.short.reddit') },
	instagramStories: { label: translationKey('fe.components.psf.share.buttons.short.instagram') },
	tiktok: { label: translationKey('corgi.psf.share.buttons.short.tiktok') },
};

type Result = ReadonlyArray<{
	ShareAction: ShareAction<PageShareChannel>['ShareAction'];
	channel: PageShareChannel;
	label: TranslationKey;
	successLabel?: TranslationKey;
	secondaryLabel?: TranslationKey;
	url: string;
	shortUrl?: string;
}>;

function isPageShareAction(action: ShareAction<ShareChannel>): action is ShareAction<PageShareChannel> {
	return action.channel in SHARE_BUTTON_CONFIG;
}

export function mapButtonConfigs(shareActions: ReadonlyArray<ShareAction<ShareChannel>>): Result {
	return shareActions.filter(isPageShareAction).map(({ ShareAction, channel, url, shortUrl }) => ({
		ShareAction,
		channel,
		url,
		shortUrl,
		...SHARE_BUTTON_CONFIG[channel],
	}));
}
